<template>
  <div class="w-full">
    <SmartTitle
      heading="1"
      weight="regular"
    >
      Validar CVS
    </SmartTitle>
    <div class="flex justify-end mb-5">
      <SmartButton
        @click="modalSuccess"
      >
        Sincronizar com GU
      </SmartButton>
    </div>
    <!-- Inicio -->
    <section>
      <v-expansion-panel>
        <v-expansion-panel-content>

          <template v-slot:header>
            <div
              class="smartListItem w-full flex flex-row justify-center align-center">
              <div class="item mt-2 flex flex-col align-center">
                <h3>Coordenador</h3>
                <SmartP>
                  {{ coordenator }}
                </SmartP>
              </div>

              <div class="item mt-2 flex flex-col align-center">
                <h3>Gerente</h3>
                <SmartP>
                  {{ manager }}
                </SmartP>
              </div>

              <div class="item mt-2 flex flex-col align-center">
                <h3>Supervisor</h3>
                <SmartP>
                  {{ supervisor }}
                </SmartP>
              </div>


              <div class="item mt-2 flex flex-col align-center">
                <h3>Soma de ausência</h3>
                <SmartP>{{ saleConsultants.length }}</SmartP>
              </div>

            </div>
          </template>
          <v-card>
            <v-card-text>
              <VDataTable
                :headers="headers"
                :items="saleConsultants"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.registration }}</td>
                  <td>{{ props.item.created_at }}</td>
                  <td>{{ props.item.motivo ? props.item.motivo : 'N/A' }}</td>
                </template>
              </VDataTable>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </section>

    <!-- Fim -->
    <SmartModal
      v-if="modal"
      v-bind="modal"
      @close="modal = null"
    >
      {{ modal.text }}
    </SmartModal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'DetailPage',
  data() {
    return {
      idPlace: this.$router.currentRoute.params.placeId,
      idSupervisor: this.$router.currentRoute.params.supervisorId,
      modal: null,
      supervisor: '',
      coordenator: '',
      manager: '',
      saleConsultants: [],
      headers: [
        { text: 'CV', value: 'cv', sortable: false },
        { text: 'Matricula', value: 'matricula', sortable: false },
        { text: 'Fora', value: 'fora', sortable: false },
        { text: 'Motivo', value: 'motivo', sortable: false }
      ]
    };
  },
  computed: {
    ...mapState({
      userStores: ({ cvs }) => cvs.userStores,
      storeSupervisors: ({ cvs }) => cvs.storeSupervisors
    }),
    saleConsultantsArray() {
      return this.saleConsultants;
    }
  },
  methods: {
    ...mapActions({
      fetchUserStores: 'cvs/fetchUserStores',
      fetchPlaceSupervisors: 'cvs/fetchPlaceSupervisors'
    }),
    Success() {
      this.modal = {
        type: 'success',
        title: 'Tudo Certo!',
        icon: 'accepted',
        buttonText: 'Ok',
        text: 'Sincronização realizada com sucesso!'
      };
    },
    start() {
      // eslint-disable-next-line
      this.storeSupervisors.supervisors.map((itemArray) => {
        // eslint-disable-next-line
        if (itemArray.id == this.idSupervisor) {
          this.saleConsultants = itemArray.sale_consultants;
          this.supervisor = itemArray.name;
          this.coordenator = itemArray.coordinators;
          this.manager = itemArray.managers;
        }
      });
    },
    modalSuccess() {
      this.Success();
    }
  },
  async mounted() {
    await this.fetchPlaceSupervisors(this.idPlace);
    this.start();
  }
};
</script>

<style lang="scss">
.v-select__slot {
  background-color: #82C85A;
}
.v-select__selections {
  background-color: white;
  width: 288px;
}
.v-input__append-inner {
  background-color: #82C85A;
}
.select-div {
 max-width: 212px;
}
td, tr {
 text-align: center !important
}
.column.text-xs-left {
  text-align: center !important;
}
.item {
  flex: 1;
}

.aux {
  width: 80%;
  padding: 16px;
  margin-top: 8px;
}

.smartListItem {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 6px;
}

.smartListItem:hover {
  background: rgba(0, 0, 0, 0.04);
}

</style>
